import { render, staticRenderFns } from "./detail-form-info.vue?vue&type=template&id=90b81228&scoped=true&"
import script from "./detail-form-info.vue?vue&type=script&lang=js&"
export * from "./detail-form-info.vue?vue&type=script&lang=js&"
import style0 from "./detail-form-info.vue?vue&type=style&index=0&id=90b81228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b81228",
  null
  
)

export default component.exports